import * as React from 'react';
import { confirmable, createConfirmation, ReactConfirmProps } from 'react-confirm';
import Modal from 'react-bootstrap/Modal';
import Button, { ButtonProps } from 'react-bootstrap/Button';
import i18n from 'i18n';

interface ConfirmationModalProps {
  title: string;
  yesOptionTitle: string;
  yesOptionVariant?: ButtonProps['variant'];
  noOptionTitle?: string;
  /** Cancel option can be hidden so dialog becomes notification. */
  isCancelHidden?: boolean;
  size?: 'sm' | 'lg' | 'xl';
}

/**
 * Confirmation dialog with promise. It is based on react-confirm.
 * https://www.npmjs.com/package/react-confirm
 */
class BlazeConfirmationModal extends React.Component<ConfirmationModalProps & ReactConfirmProps> {
  render() {
    return (
      <Modal
        show={this.props.show}
        onHide={() => this.props.cancel()}
        size={this.props.size ? this.props.size : undefined}
      >
        <div className="modal-header">
          <h5 className="modal-title" id="qa-confirmation-modal-title">
            {this.props.title}
          </h5>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label={i18n.t('common:actions.close')}
            id={'qa-view-confirmation-modal-btn-close-icon'}
            title={i18n.t('common:actions.close')}
            onClick={() => this.props.cancel()}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <Modal.Body>{this.props.confirmation}</Modal.Body>

        <Modal.Footer>
          {this.props.isCancelHidden !== true && (
            <Button variant="link" onClick={() => this.props.cancel()}>
              {this.props.noOptionTitle ? this.props.noOptionTitle : i18n.t('common:actions.cancel')}
            </Button>
          )}
          <Button
            variant={this.props.yesOptionVariant ? this.props.yesOptionVariant : 'danger'}
            onClick={() => this.props.proceed()}
          >
            {this.props.yesOptionTitle ? this.props.yesOptionTitle : 'Yes'}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

/**
 * Adds ReactConfirmProps to CustomModal component with HOC
 */
const ConfirmModal = confirmable(BlazeConfirmationModal);

/**
 *  This is the function you need to call to open your modal,
 *  then you can use the promise object it returns to handle "proceed()" or "cancel()" functions.
 */
export const confirm = createConfirmation(ConfirmModal);
